import axios from "axios";
import { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import {useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner";
import UpdateComplete from "./modals/UpdateComplete";
import SideMenu from "../../components/SideMenu";
export default function EditProduct() {

  //props
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
const navi = useNavigate()
  const [updateComplete,setUpdateComplete] = useState(false)
  const [clubId,setClubId] = useState("")


 const [isLoading, setIsLoading] = useState(false);

  const { id } = useParams();
  const { user,dispatch } = useAuthContext()

    //Static Name wont change
  const [staticName,setStaticName] = useState("")



  
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const prodResponse = await axios.get(
        `${ApiConnectionString}/api/product/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setName(prodResponse.data.name);
      setDescription(prodResponse.data.description);
      setStaticName(prodResponse.data.name);
      setClubId(prodResponse.data.clubId)

      
   
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }finally{
      setIsLoading(false)
    }
  };
  
  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
  
    const editProduct = {
      id,
      name,
      description
    };
  
    try {
      const response = await axios.put(
        `${ApiConnectionString}/api/product`,
        editProduct,
        {
          headers: { Authorization: `bearer ${user.token}` }
        }
      );
  
      if (response.status === 200) {
        setUpdateComplete(true)
      }
    } catch (error) {
      console.error(error);
      // Handle any errors that occur during the update
    } finally {
      setIsLoading(false);
    }
  };
  

  if(isLoading){
    return(
      <div>
        <LoadingSpinner />
      </div>
    )
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-3 side-menu-container">
          <SideMenu />
        </div>
        <div className="col bg-white mx-5 my-2 p-0 ">
          <div className="blueBanner">
            <p className="text-white p-3 mx-3 my-0 fw-bold fontSize20 ">
              Edit Product : {staticName}
            </p>
          </div>

          <div className="d-flex justify-content-end">
        
            <button
              onClick={() => navi(`/myoneproduct/${id}`)}
              className="settings-menu-button"
            >
              Go Back
            </button>
        
          </div>
          
          
          
              <form onSubmit={handleSubmit}>
    <table className="m-2">
        <tbody>
          <tr>
            <th className="red-text">Title:</th>
            <td>
              <input value={name} onChange={(e) => setName(e.target.value)} />
            </td>
          </tr>
          <tr>
            <th className="red-text">Description:</th>
            <td>
              <input
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <p>If you need to change anything other than the title and description, please note that these aspects cannot be modified. In such cases, you may consider deleting the product and creating a new one.</p>

    <button className="saveChanges-button mx-4">Update</button>
    </form></div></div>
     


    
    
    {updateComplete && <UpdateComplete id={clubId} />}</div>
  );
}
